import { gql } from '@apollo/client';

export default gql`
  mutation deleteFormOperation($_id: String) {
    deleteFormOperation(_id: $_id) {
      ok
      message
      error
    }
  }
`;
